import { AiArtifactConfig, WidgetSpec } from 'shared/types/widgets'
import { create } from 'zustand'

type GridContext = {
  source: 'grid'
  dragType?: 'item' | 'shortcut-group'
  groupId?: string
  itemId: string
  itemIds: string[]
  size: { width: number; height: number }
  dragOffset: { x: number; y: number }
}

// shared shape used by WidgetMarketplace, the touch drop zone, and the
// desktop drag-and-drop read path so each consumer doesn't re-type it
export type MarketplaceDragPayload = WidgetSpec & {
  source: 'marketplace'
  config?: AiArtifactConfig
}

export type DragContext =
  | GridContext
  | (MarketplaceDragPayload & { source: 'marketplace' })

type DragStore = {
  context: DragContext | null
  setContext: (ctx: DragContext | null) => void
  clearContext: () => void
}

export const useDragStore = create<DragStore>(set => ({
  context: null,
  setContext: ctx => set({ context: ctx }),
  clearContext: () => set({ context: null })
}))

export const getDragContext = () => useDragStore.getState().context
export const setDragContext = (ctx: DragContext | null) =>
  useDragStore.getState().setContext(ctx)
